import { Inject, Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { timeout, map, catchError } from 'rxjs/operators';

import { HttpService } from '../../shared';
import { ConfigService } from '../../shared/config/config.service';

import { APP_CONFIG, IAppConfig } from '../../shared/config/app.config';
import { ServiceLocator } from '../../shared/serviceLocator.injector';

@Injectable()
export class TpaService extends HttpService {

  public dialogErrors: any[];
  public config: ConfigService;
  public notifyPageChange = new Subject<any>();
  public http: HttpClient;
  public initPages = new Subject<any>();
  private printerSetRouteData: any;
  private tpaObject: any;
  private printerObject: any;
  private printerSetObject: any;
  private officeType: any;
  private searchType: string;
  private errorMessage: any[];
  private hasChange = false;
  private officeData = {
    nsOffId: '',
    amdOff: '',
    amidId: '',
    setMnem: '',
    vendorId: '',
    airlnId: '',
    secSMne: ''
  };

  constructor() {
    super();
    this.http = ServiceLocator.injector.get(HttpClient);
    this.config = ServiceLocator.injector.get(ConfigService);
  }

  /***
   * Function to set Search Parameter for Tpa
   * @param tpaObject, Tpa search input
   */
  public setTpaInput(tpaObject: any) {
    this.tpaObject = tpaObject;
  }

  /***
   * Function to get Search Parameter for Tpa
   * @return tpaObject, Tpa search input
   */
  public getTpaInput(): any {
    return this.tpaObject;
  }

  public setSearchType(type: string) {
    this.searchType = type;
  }

  public getSearchType(): string {
    return this.searchType;
  }

  public setHasChange(type: boolean) {
    this.hasChange = type;
  }

  public getHasChange(): boolean {
    return this.hasChange;
  }

  public setOfficeSearchType(officeType: string) {
    this.officeType = officeType;
  }

  public getOfficeSearchType() {
    return this.officeType;
  }

  public getDataFromServer(searchCreteria: any) {
    let bodyString = JSON.stringify(searchCreteria);
    const tpaConfigData = this.config.getConfig('tpa');
    let url = this.getAPIEndPoint(this.config.arpOrigin, this.config.arpUsap, tpaConfigData.apiEndPoint) + this.getUsap(this.config.arpUsap, this.config.getTpaUsap()) +
      tpaConfigData.search.version +
      tpaConfigData.search.uri;

    let data = this.http.post(
      url,
      bodyString
    )
      .pipe(
        timeout(59000),
        map(super.extractData),
        catchError(this.handleError.bind(this))
      );
    return data;
  }

  public setOfficeData(officeData: any) {
    this.officeData = officeData;
  }
  public getOfficeData() {
    return this.officeData;
  }
  public setErrorMessage(message: any[]) {
    this.errorMessage = message;
  }
  public getErrorMessage(): any[] {
    return this.errorMessage;
  }

  public setDialogErrors(errors: any[]) {
    this.dialogErrors = errors;
  }

  public getDialogErrors(errors?: any[]) {
    return this.dialogErrors;
  }
  public checkLockStatus(data: any) {
    const offConfigData = this.config.getConfig('office');
    let url = this.getAPIEndPoint(this.config.arpOrigin, this.config.arpUsap, offConfigData.apiEndPoint) + this.getUsap(this.config.arpUsap, this.config.getOffUsap()) + 'offices/lockstatus/';
    if (data.amid) {
      url += 'amid/' + data.amid;
    } else if (data.amdOff) {
      url += 'officelabel/' + data.amdOff;
    } else if (data.nsOffId) {
      url += 'of_nsid_airline/' + data.nsOffId;
    }
    let response = this.http.get(url)
      .pipe(
        timeout(59000),
        map(super.extractData),
        catchError(this.handleError.bind(this))
      );
    return response;
  }
  public setPrinterSetRouteData(data: any) {
    this.printerSetRouteData = data;
  }
  public getPrinterSetRouteData(): any {
    return this.printerSetRouteData;
  }
}